function ServiceModal({ service, onClose, onDiscuss }) {
  if (!service) {
    return null;
  }

  return (
    <div className="modal-layer" role="presentation" onClick={onClose}>
      <div className="modal" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <button className="modal-close" type="button" onClick={onClose}>
          ×
        </button>
        <img src={service.image} alt={service.title} loading="lazy" decoding="async" />
        <span className="section-kicker">{service.label}</span>
        <h2>{service.title}</h2>
        <p>{service.short}</p>
        <ul>
          {service.details.map((detail) => (
            <li key={detail}>{detail}</li>
          ))}
        </ul>
        <button className="button button-primary" type="button" onClick={onDiscuss}>
          Обсудить услугу
        </button>
      </div>
    </div>
  );
}

export default ServiceModal;
